import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M12 1c6.075 0 11 4.925 11 11s-4.925 11-11 11S1 18.075 1 12 5.925 1 12 1m0 1.65a9.35 9.35 0 1 0 0 18.7 9.35 9.35 0 0 0 0-18.7m2.37 5.813a.825.825 0 0 1 1.166 1.166L13.166 12l2.37 2.37a.825.825 0 1 1-1.166 1.167l-2.371-2.37-2.37 2.37a.826.826 0 0 1-1.167-1.166L10.832 12l-2.37-2.37a.825.825 0 0 1 1.167-1.167l2.37 2.37z"
    }, null, -1)
  ]))]))
}
export default { render: render }